import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { RequisitionStatus } from '@recruitee/requisitions-types';
import { BadgeComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-requisitions-status-badge',
  templateUrl: './requisitions-status-badge.component.html',
  styleUrls: ['./requisitions-status-badge.component.less'],
  imports: [BadgeComponent, TranslatePipe],
})
export class RequisitionsStatusBadgeComponent {
  @Input() public status: RequisitionStatus;
  @Input() public isArchived: boolean;
  public RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
}
